/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolYardIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-yard"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 19.15Q12 17.9 11.55 16.76Q11.1 15.63 10.22 14.75Q9.5 14.03 8.56 13.55Q7.63 13.07 6.58 13Q6.28 12.97 6.05 13.2Q5.83 13.43 5.85 13.72Q5.92 14.78 6.4 15.7Q6.88 16.63 7.6 17.35Q8.47 18.23 9.61 18.69Q10.75 19.15 12 19.15ZM12 14.35Q12 14.35 12.32 14.35Q12.65 14.35 13.13 13.88Q13.6 13.4 13.6 12.75L13.6 12.6L13.6 12.6Q13.8 12.75 14.01 12.82Q14.22 12.9 14.5 12.9Q15.15 12.9 15.63 12.43Q16.1 11.95 16.1 11.3Q16.1 10.8 15.86 10.45Q15.63 10.1 15.2 9.9L15.2 9.9L15.2 9.9Q15.63 9.7 15.86 9.35Q16.1 9 16.1 8.5Q16.1 7.85 15.63 7.38Q15.15 6.9 14.5 6.9Q14.22 6.9 14.01 6.97Q13.8 7.05 13.6 7.2L13.6 7.2L13.6 7.05Q13.6 6.4 13.13 5.92Q12.65 5.45 12 5.45Q11.35 5.45 10.88 5.92Q10.4 6.4 10.4 7.05L10.4 7.2L10.4 7.2Q10.2 7.05 9.99 6.97Q9.78 6.9 9.5 6.9Q8.85 6.9 8.38 7.38Q7.9 7.85 7.9 8.5Q7.9 9 8.14 9.35Q8.38 9.7 8.8 9.9L8.8 9.9L8.8 9.9Q8.38 10.1 8.14 10.45Q7.9 10.8 7.9 11.3Q7.9 11.95 8.38 12.43Q8.85 12.9 9.5 12.9Q9.78 12.9 9.99 12.82Q10.2 12.75 10.4 12.6L10.4 12.6L10.4 12.75Q10.4 13.4 10.88 13.88Q11.35 14.35 12 14.35ZM12 11.15Q12 11.15 11.74 11.15Q11.47 11.15 11.11 10.79Q10.75 10.43 10.75 9.9Q10.75 9.38 11.11 9.01Q11.47 8.65 12 8.65Q12.53 8.65 12.89 9.01Q13.25 9.38 13.25 9.9Q13.25 10.43 12.89 10.79Q12.53 11.15 12 11.15ZM12 19.15Q13.25 19.15 14.39 18.7Q15.53 18.25 16.4 17.38Q17.13 16.65 17.6 15.71Q18.07 14.78 18.15 13.72Q18.18 13.43 17.95 13.2Q17.73 12.97 17.43 13Q16.38 13.07 15.45 13.55Q14.53 14.03 13.8 14.75Q12.93 15.63 12.46 16.76Q12 17.9 12 19.15ZM3.85 22.8Q2.75 22.8 1.98 22.02Q1.2 21.25 1.2 20.15L1.2 3.85Q1.2 2.75 1.98 1.98Q2.75 1.2 3.85 1.2L20.15 1.2Q21.25 1.2 22.02 1.98Q22.8 2.75 22.8 3.85L22.8 20.15Q22.8 21.25 22.02 22.02Q21.25 22.8 20.15 22.8Z" fill={color} />
    </svg>
  );
}
